import { defaultSchema } from "rehype-sanitize";

// Trusted embed domains for iframe src
const TRUSTED_DOMAINS = [
  "plotly.com",
  "chart-studio.plotly.com",
  "github.com",
  "gist.github.com",
  "github.dev",
  "observablehq.com",
  "nbviewer.org",
  "nbviewer.jupyter.org",
  "youtube.com",
  "www.youtube.com",
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
  "docs.google.com",
  "codepen.io",
  "codesandbox.io",
];

function isTrustedSrc(value) {
  if (!value || typeof value !== "string") return false;
  try {
    const url = new URL(value, "https://placeholder.invalid");
    return TRUSTED_DOMAINS.some(
      (d) => url.hostname === d || url.hostname.endsWith("." + d)
    );
  } catch {
    return false;
  }
}

export const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), "iframe"],
  attributes: {
    ...defaultSchema.attributes,
    iframe: ["src", "width", "height", "frameBorder", "allowFullScreen", "title", "style"],
  },
  // Filter iframe src to trusted domains only
  // rehype-sanitize doesn't have built-in URL filtering for arbitrary attrs,
  // so we rely on the allowedValues approach via a custom handler below.
};

// Post-sanitize: strip iframes with untrusted src
export function filterUntrustedIframes(tree) {
  visit(tree);
  return tree;
}

function visit(node) {
  if (!node || !node.children) return;
  node.children = node.children.filter((child) => {
    if (child.tagName === "iframe") {
      const src = child.properties?.src || "";
      return isTrustedSrc(src);
    }
    return true;
  });
  node.children.forEach(visit);
}
